function Title({ name }) {
  return (
    <div className="flex flex-row items-center text-main gap-3 px-4">
      <div>
        <img src="./lookie.webp" className="h-6 w-6 md:h-8 md:w-8" alt=""></img>
      </div>
      <div className="text-lg md:text-xl lg:text-2xl tracking-widest font-bold">
        {name}
      </div>
    </div>
  );
}

export default Title;
